import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
const UPDATE_NOTE_TAB_MUTATION = gql `
  mutation Admin_UpdateNoteTab($noteTabID: ID!, $data: EPNoteTabUpdateInput!) {
    ep_editNoteTab(noteTabID: $noteTabID, data: $data)
  }
`;
export function useUpdateNoteTabMutation(options) {
    return useGQLMutation(UPDATE_NOTE_TAB_MUTATION, {
        ...options,
        update(cache, _, { variables }) {
            if (!variables?.noteTabID) {
                return;
            }
            const { noteTabID, data: inputData } = variables;
            cache.modify({
                id: cache.identify({
                    __typename: 'EPNoteTab',
                    id: noteTabID,
                }),
                fields: {
                    data(existingData) {
                        if (!existingData)
                            return inputData;
                        return {
                            ...existingData,
                            title: inputData.title ?? existingData.title,
                            content: inputData.content ?? existingData.content,
                            version: (inputData.version ?? existingData.version ?? 0) + 1,
                        };
                    },
                },
            });
        },
    });
}
